import { useMemo } from "react";

import clsx from "clsx";

import { CounterList, ImageLegacy } from "@/components/displays";

import styles from "./Instructions.module.scss";

export interface InstructionsProps {
  instructions: {
    title?: string;
    description?: string;
    point?: string;
  }[];
}

export function Instructions({ instructions }: InstructionsProps): React.ReactNode {
  const contents = useMemo(() => {
    return instructions.map(({ title, description, point }) => ({
      title: title,
      description: description,
      extraDescription: point && (
        <>
          <ImageLegacy
            src="https://asset.basefood.co.jp/images/ph/ph_recipe_point.png"
            alt="point"
            size={{ width: 37.5, height: 12.5 }}
          />
          <p className="text__yellow__dark">{point}</p>
        </>
      ),
    }));
  }, [instructions]);
  return (
    <>
      <p className={clsx("text__l text__bold pd__bottom__s", styles.instructionsBorderBottomSolid)}>
        作り方
      </p>
      <CounterList contents={contents} />
    </>
  );
}
